const firstLetterCap = text => text.replace(/(\b[a-z](?!\s))/g, x => x.toUpperCase());
const removeSpecialCharacters = text => text.replace(/[^\d\sA-Za-z]/g, '');
const removeSpaces = text => text.replace(/\s/g, '');
const getSmallCase = text => text.toLowerCase();
const slugify = text => text.toString().toLowerCase().replace(/\s+/g, '-') // replace whitespace with dashes
.replace(/[^\w-]+/g, '') // anything remaining that's not a "word character", strip it
.replace(/--+/g, '-') // replace sequences of dashes with a single dash
.replace(/^-+/, '') // strip dashes at beginning of string
.replace(/-+$/, ''); // strip dashes at end of string

export { firstLetterCap, getSmallCase, removeSpaces, removeSpecialCharacters, slugify };
